<template>
  <form class="form form-horizontal" v-on:submit="submitForm">
    <modal
      :is-hidden="isHidden"
      :is-open="isOpen"
      :title="$t('OrderDetails.orderProject')"
      ref="modal"
      v-on:clickclose="closeDialog"
      :alert="alertTitle"
      :alert-style="alertStyle"
      :alert-text="alertText"
      :alert-icon="alertIcon"
      alert-dismissable
      v-on:dismissalert="closeAlert"
      v-on:close="reset"
      :fixed="true"
    >
      <div class="pad-20" v-if="activeRequest">
        <div class="progress">
          <div class="progress-bar progress-bar-success progress-bar-striped active" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width: 100%">
              <span class="sr-only">{{ $t('OrderDetails.creatingOrder') }}</span>
          </div>
        </div>
        <div class="a-c">{{ $t('OrderDetails.creatingOrder') }}</div>
      </div>
      <template v-if="!activeRequest">
        <field type="multi" name="description" :label="$t('Common.annotation')" v-model="form.description"></field>
        <div class="b_t ptop-20 mtop-20">
          <input type="checkbox" v-model="checkTerms"> <span v-html="termsHtml"></span>
        </div>
      </template>
      <template slot="footer">
        <button type="button" class="btn btn-sm btn-default" :disabled="activeRequest" v-on:click="closeDialog">{{ $t('Action.close') }}</button>
        <button type="submit" class="btn btn-sm btn-success" :disabled="activeRequest"><i v-if="activeRequest" class="fa fa-spinner fa-spin"></i> {{ $t('OrderDetails.placeOrder') }}</button>
      </template>
    </modal>
  </form>
</template>

<script>
var view = require('../view.js'),
    viewData = {
      isHidden: true,
      isOpen: false,
      activeRequest: false,
      alertTitle: '',
      alertText: '',
      alertStyle: '',
      alertIcon: '',
      form: {
        description: ''
      },
      checkTerms: false
    },
    resetData = Object.assign({}, viewData);

export default view(viewData, {
  props: {
    projectId: {},
    cartSections: {
      type: Array
    }
  },
  computed: {
    termsHtml() {
      return this.$t('OrderDetails.acceptTerms', {termsUrl: this.$root.termsUrl})
    },
    image() {
      if (this.$parent.files.length > 0)
        return this.$parent.previewImage(this.$parent.files[0]);
    }
  },
  mounted() {
    this.reset();
  },
  methods: {
    reset() {
      for (var i in resetData) {
        if (resetData.hasOwnProperty(i)) {
          if (typeof resetData[i] != 'object' && i != 'isHidden' && i != 'isOpen') {
            viewData[i] = resetData[i];
          }
        }
      }
    },
    submitForm(evt) {
      evt.preventDefault();

      if (!this.checkTerms) {
        this.alertTitle = 'Bitte akzeptieren Sie unsere AGB.';
        return;
      }

      this.closeAlert();
      this.activeRequest = true;
      this.$http.post(this.$root.url + 'order/', {
        projectId: this.projectId,
        form: this.form,
        items: this.cartSections,
        image: this.image
      }).then(
        function(res) {
          this.activeRequest = false;
          this.$emit('ordercreated', res.data.result);

          if (typeof gtag != 'undefined') {
            gtag('event', 'place_order', {
              'event_label': res.data.result.ordernum
            });
          }

          this.closeDialog();
        }.bind(this),
        function(res) {
          this.activeRequest = false;
          this.alertTitle = 'Projekt konnte nicht angelegt werden.';
        }.bind(this));
    },
    closeDialog() {
      if (!this.activeRequest) {
        this.$refs.modal.close(this);
      }
    },
    openDialog(description) {
      this.form.description = description;
      this.$refs.modal.open(this);
    },
    closeAlert() {
      this.alertTitle = '';
      this.alertText  = '';
      this.alertStyle = '';
      this.alertIcon  = '';
    }
  }
});
</script>
